<template>
    <div style="margin-bottom: 15px;">
				{{ criterion.comment }}
<!--        {{ getMyScoreDataByCriterion(projectinfo, expert, criteria, 1).comment|default('') }}-->
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EditExpertComments",
	data() {
    return {
      criterion: {
        comment: ''
			}
		}
	},
	props: {
    pi_id: {},
    user_id: {},
    criteria_id: {},
    tour: {}
	},
	async created() {
    const response = await axios.post('/competition/getMyScoreDataByCriterion', null, {
      params: {
        pi_id: this.pi_id,
        user_id: this.user_id,
        crit_id: this.criteria_id,
        tour: this.tour
      }
    })
		console.log(response.data);
    this.criterion = response.data;
  }
}
</script>

<style scoped>

</style>